'use client';

import { Check, X } from 'lucide-react';
import type { JSX } from 'react';

interface IPasskeyStatusDisplayProps {
  hasPasskey: boolean;
}

export function PasskeyStatusDisplay({ hasPasskey }: IPasskeyStatusDisplayProps): JSX.Element {
  if (hasPasskey) {
    return (
      <div className="flex items-center gap-2">
        <Check className="h-4 w-4 text-green-500" />
        <span className="text-sm text-muted-foreground">Enabled</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <X className="h-4 w-4 text-muted-foreground" />
      <span className="text-sm text-muted-foreground">Not set up</span>
    </div>
  );
}
